import React from 'react'
import { Input, Text } from 'pcln-design-system'
import { User as UserIcon } from 'pcln-icons'
import styled from 'styled-components'
import StyledMenuButton from './StyledMenuButton'

const TEXT_MARGIN_LEFT = 36

const StyledInput = styled(Input)`
  position: absolute;
  height: 56px;
`

const StyledText = styled(Text)`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: left;
  width: calc(100% - ${TEXT_MARGIN_LEFT}px);
`

type MenuProp = {
  isPanelOpen: boolean
  hasError: boolean
  label: string
  isMobile: boolean
  toggleMenu: (isPanelOpen: boolean) => void
}

export default function Menu({
  isPanelOpen = false,
  hasError = false,
  label = '',
  toggleMenu,
  isMobile
}: MenuProp) {
  const borderColorValue = !isPanelOpen && hasError ? 'error' : 'borderGray'
  return (
    <StyledMenuButton
      type="button"
      color="text.lightest"
      width={1}
      isMobile={isMobile}
      onClick={toggleMenu(isPanelOpen)}
      borderColor={borderColorValue}
      aria-label="traveler-selection-control-panel"
      aria-expanded={isPanelOpen}
      aria-controls="traveler-selection-control-panel"
    >
      <UserIcon color="primary" size={24} ml={10} />
      <StyledText
        fontSize={1}
        fontWeight={500}
        fontFamily="inherit"
        ml={TEXT_MARGIN_LEFT}
      >
        {label}
      </StyledText>
      <StyledInput
        readOnly
        type="text"
        tabIndex={-1}
        aria-live="polite"
        borderRadius="lg"
        aria-atomic="true"
        aria-label="traveler selection"
        id="traveler-selection-readonly-input"
        data-testid="traveler-selection-readonly-input"
      />
    </StyledMenuButton>
  )
}
